import { addTyped } from './probeFields';

/**
 * A rank check's searches as badges, each with an × to take it off, above the
 * box they are typed into. Typing a comma or pressing Enter makes a badge, so
 * it is plain the list was read the way it was meant.
 */
export default function KeywordBadges({
  list,
  draft,
  limit,
  placeholder,
  loading,
  onChange,
}: {
  list: string[];
  draft: string;
  limit: number;
  placeholder: string;
  loading?: boolean;
  onChange: (list: string[], draft: string) => void;
}) {
  const type = (text: string, finish = false) => {
    const next = addTyped(list, text, limit, finish);
    onChange(next.list, next.draft);
  };
  return (
    <div className="mt-0.5">
      {list.length > 0 && (
        <div className="mb-1 flex flex-wrap gap-1" data-testid="keyword-badges">
          {list.map(k => (
            <span
              key={k}
              className="inline-flex items-center gap-1 rounded bg-indigo-50 px-1.5 py-0.5 text-[11px] text-indigo-800 dark:bg-indigo-900/40 dark:text-indigo-100"
            >
              {k}
              <button
                type="button"
                onClick={() =>
                  onChange(
                    list.filter(x => x !== k),
                    draft,
                  )
                }
                aria-label={`Remove ${k}`}
                className="text-indigo-500 hover:text-red-600 dark:text-indigo-300 dark:hover:text-red-300"
              >
                ×
              </button>
            </span>
          ))}
          <span className="self-center text-[11px] text-gray-500 dark:text-gray-400">
            {list.length} of {limit}
          </span>
        </div>
      )}
      <input
        type="text"
        value={draft}
        disabled={loading}
        onChange={e => type(e.target.value)}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            type(draft, true);
          }
        }}
        onBlur={() => draft.trim() && type(draft, true)}
        placeholder={loading ? 'Loading…' : list.length >= limit ? `${limit} is the most one check takes` : placeholder}
        className="w-full rounded border border-gray-300 px-2 py-1 text-xs dark:border-gray-600 dark:bg-gray-900"
      />
    </div>
  );
}
